import { render } from "./BienBanCompleteButton.vue?vue&type=template&id=3aa3e5a8&ts=true"
import script from "./BienBanCompleteButton.vue?vue&type=script&lang=ts"
export * from "./BienBanCompleteButton.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__